<template>
  <div class="row no-gutters">
    <!--Password Input Field Column-->
    <div class="col-12 col-lg-6 pr-lg-1 pr-xl-3">
      <div>
        <div class="form-group">
          <field-label :fieldData="fieldElement['password']"></field-label>

          <field-tooltip :fieldData="fieldElement['password']"></field-tooltip>

          <input-password
            :fieldData="fieldElement['password']"
            :inputType="passwordInputType">
          </input-password>
        </div>
      </div>

      <div>
        <div class="form-group">
          <field-label :fieldData="fieldElement['passwordConfirm']"></field-label>

          <field-tooltip :fieldData="fieldElement['passwordConfirm']"></field-tooltip>

          <input-password
            :fieldData="fieldElement['passwordConfirm']"
            :inputType="passwordInputType">
          </input-password>

          <field-messages :fieldData="fieldElement['passwordConfirm']"></field-messages>
        </div>
      </div>

      <div>
        <div class="form-group ml-4">
          <input-checkbox :fieldData="fieldElement['passwordExpose']"></input-checkbox>

          <field-label :fieldData="fieldElement['passwordExpose']" class="float-left small qrp-text-muted"></field-label>

          <field-tooltip :fieldData="fieldElement['passwordExpose']"></field-tooltip>
        </div>
      </div>
    </div>

    <!--Password Strength Column-->
    <div class="col-12 col-lg-6 mt-sm-3 mt-lg-0 pl-lg-2 pl-xl-3 pr-0">
      <password-strength :fieldData="fieldElement['password']"></password-strength>
    </div>
  </div>
</template>

<script>
import PasswordStrength from '../../presentational/alerts/PasswordStrength';
import InputPassword from '../InputPassword';
import InputText from '../InputText';
import InputCheckbox from '../InputCheckbox';
import FieldLabel from '../../presentational/FieldLabel';
import FieldMessages from '../../presentational/FieldMessages';
import FieldTooltip from '../../presentational/FieldTooltip';

export default {
  inject: ['$validator'], // Allows this component's validation messages to appear in other components
  props: ['fieldElement', 'passwordInputType'],
  data() {
    return {
    };
  },
  components: {
    PasswordStrength,
    InputPassword,
    InputText,
    InputCheckbox,
    FieldLabel,
    FieldMessages,
    FieldTooltip,
  },
};
</script>

<style scoped>
  #main-card {
    border-color: #F7F7F7;
    margin-top: 4rem;
  }

  #login-card-hr {
    margin: 0.625rem 0;
  }

  #login-card-hr-bottom {
    margin-bottom: .25rem;
  }

  #qrp-logo{
    display: block;
    width: 75%;
    max-width: 230px;
    height: inherit !important;
    margin:0 auto;
  }

  .input-group-prepend svg{
    color: #666666;
    fill: currentcolor;
  }
form h1{
  font-size: 1.375rem !important;
}

#main-footer {
  margin-bottom: 1rem;
  padding-top: .7rem;
  font-size: 0.75rem;
  text-align: center;
}

a.text-link{
  cursor: pointer;
}
a.text-link:hover{
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/components/interactive/widgets/PasswordUpdate.vue?1f13cb1e